import { AutoMap } from '@automapper/classes';

export class ProcessCalculationEntity {
    Id?: number;
    @AutoMap()
    Duration!: number;
    @AutoMap()
    SamplingMode!: number;
}
